"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.CheckMarker = void 0;
var react_1 = __importDefault(require("react"));
var CheckMarker = function () {
    return (react_1.default.createElement("svg", { width: "13", height: "12", viewBox: "0 0 13 12", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        react_1.default.createElement("path", { d: "M10.5898 3L5.08984 8.5L2.58984 6", stroke: "white" })));
};
exports.CheckMarker = CheckMarker;
